export default {
  "nav.thesis": "Tesis",
  "nav.disciplines": "Disciplinas",
  "nav.horizon": "Horizonte",
  "nav.join": "Aplica",
  "nav.backus": "Suscríbete",
  "nav.invest": "Apóyanos",

  "hero.badge": "Ingeniería de la Longevidad",
  "hero.l1": "La inmortalidad humana es teórica.",
  "hero.l2": "150 años es práctico.",
  "hero.sub": "La longevidad es un desafío humano multidisciplinario. La Medicina y las Ciencias de la Salud han impulsado avances notables en longevidad. Los próximos grandes avances pueden surgir de su convergencia con la ingeniería, la IA, la neurología, la psicología, la ciencia cognitiva, la mecánica cuántica, la física de partículas y el espacio-tiempo.",
  "hero.sub2": "The Lifespan Project reúne estas disciplinas. Nada en las leyes conocidas de la física parece prohibir una vida humana mucho más larga. Tenemos la intención de investigar y demostrar lo que es posible.",
  "hero.cta1": "Suscríbete al Proyecto",
  "hero.cta2": "Lee la Tesis",
  "hero.stats1": "09 Disciplinas",
  "hero.stats2": "Escala Subliminal",
  "hero.stats3": "Primeras Soluciones ≤ 24 Meses",
  "hero.caption": "Investigación a escala subliminal en curso",

  "mq.1": "Espacio-Tiempo",
  "mq.2": "Física de Partículas",
  "mq.3": "Mecánica Cuántica",
  "mq.4": "Computación IA",
  "mq.5": "Biología",
  "mq.6": "Neurología",
  "mq.7": "Psicología",
  "mq.8": "Ciencia Cognitiva",
  "mq.11": "Ciencias de la Salud",
  "mq.12": "Ciencia Médica",
  "mq.9": "Longevidad",
  "mq.10": "150+ Años",

  "mani.eyebrow": "El Manifiesto",
  "mani.h2a": "La muerte es el",
  "mani.h2b": "problema sin resolver",
  "mani.h2c": "más antiguo de la física.",
  "mani.c1t": "La Tesis",
  "mani.c1b": "Envejecer no es una ley de la naturaleza; es un problema de ingeniería sin resolver. Creemos firmemente que el ser humano puede alcanzar la inmortalidad en teoría, y una vida de más de 150 años en la práctica, en un futuro cercano. Cada disciplina que tocamos apunta en la misma dirección.",
  "mani.c2t": "El Método",
  "mani.c2b": "Nuestros programas de investigación y computación operan a escala subliminal: por debajo del ruido, a través de toda la materia y la mente. De las interacciones de partículas a la computación neuronal, modelamos la vida como un sistema que puede entenderse, simularse y extenderse.",
  "mani.c3t": "El Horizonte",
  "mani.c3b": "Esto no es un proyecto de un siglo. En los próximos dos años lanzaremos nuestras primeras soluciones; los primeros artefactos de un programa mucho mayor. Lo que sigue se multiplica.",
  "mani.c4t": "El Modelo",
  "mani.c4b": "Nuestra investigación se sostiene con un amplio ecosistema: patrocinadores, inversores, suscriptores académicos, filántropos, grandes patrimonios, empresarios, empresas colaboradoras y patrocinadores corporativos. Los productos y servicios fluyen a través de The Lifespan Labs para mantener la investigación en marcha; son el motor, nunca el propósito.",

  "disc.eyebrow": "La Estructura",
  "disc.h2a": "Nueve disciplinas.",
  "disc.more": "Cómo converge",
  "disc.converge": "Medicina × Física × Longevidad",
  "disc.h2b": "Una variable.",
  "disc.sub": "La longevidad no es solo un problema de biología. Es un problema de sistema completo, de las partículas a la conciencia.",
  "disc.d1n": "Espacio-Tiempo y Materia",
  "disc.d1d": "La vida se desarrolla dentro de un tejido físico. Estudiamos cómo la materia se organiza, persiste y se repara a través del tiempo.",
  "disc.d1x": "La medicina mide el envejecimiento en años; la física pregunta qué es el tiempo mismo. Al estudiar cómo la materia se organiza y persiste en el espacio-tiempo, buscamos las palancas más profundas que permiten a los sistemas vivos resistir el deterioro.",
  "disc.d2n": "Física de Partículas",
  "disc.d2d": "En las escalas más pequeñas están las reglas que todo lo demás obedece.",
  "disc.d2x": "Cada fármaco, célula y pensamiento está hecho de partículas que obedecen reglas precisas. Comprender esas reglas en las escalas más pequeñas permite a la medicina diseñar intervenciones con precisión atómica en lugar de aproximaciones.",
  "disc.d3n": "Mecánica Cuántica",
  "disc.d3d": "Coherencia, decoherencia y la base cuántica de la maquinaria biológica.",
  "disc.d3x": "La vida ya funciona con maquinaria cuántica: enzimas, fotosíntesis y posiblemente la cognición. Donde la medicina se encuentra con la física cuántica, exploramos la coherencia, el efecto túnel y la detección como nuevas herramientas para leer y reparar la biología.",
  "disc.d4n": "IA y Computación",
  "disc.d4d": "La simulación y la inteligencia artificial comprimen décadas de ensayo biológico en días de cómputo.",
  "disc.d4x": "La IA comprime décadas de ensayo y error médico en días de simulación. Combinada con modelos físicos del cuerpo, nos permite probar moléculas y terapias in silico antes de que lleguen a un paciente.",
  "disc.d5n": "Biología",
  "disc.d5d": "Reparación celular, senescencia y regeneración: las palancas directas de la longevidad.",
  "disc.d5x": "La biología da a la medicina sus objetivos: reparación celular, senescencia y regeneración. Combinada con mediciones de precisión física, el envejecimiento pasa de misterio a especificación de ingeniería.",
  "disc.d6n": "Neurología",
  "disc.d6d": "El cerebro es el núcleo irremplazable. Protegerlo y extenderlo no es negociable.",
  "disc.d6x": "El cerebro es donde la medicina aún no puede reemplazar lo que falla. La neurología converge con la física y la computación para proteger, conectar y un día extender el núcleo irremplazable de lo que somos.",
  "disc.d7n": "Psicología y Ciencia Cognitiva",
  "disc.d7d": "Una vida más larga debe seguir siendo una vida que valga la pena: mente, memoria y significado incluidos.",
  "disc.d7x": "Una vida más larga solo importa si la mente prospera. La ciencia cognitiva y la medicina cartografían juntas cómo la memoria, la motivación y el significado cambian con la edad, para que los años añadidos sigan valiendo la pena.",
  "disc.d8n": "Ciencias de la Salud",
  "disc.d8d": "La salud pública, la nutrición y la prevención, las palancas a escala poblacional que ya han sumado décadas a la vida humana.",
  "disc.d8x": "La salud pública sumó décadas a la vida humana sin una sola píldora: saneamiento, nutrición, prevención. Medidas con precisión física, estas palancas poblacionales se convierten en infraestructura programable para la longevidad.",
  "disc.d9n": "Ciencia Médica",
  "disc.d9d": "La medicina clínica convierte la investigación en longevidad en práctica: diagnósticos, terapias y cuidados que amplían los años saludables.",
  "disc.d9x": "La medicina convierte cada descubrimiento en práctica. Al converger con la física y la ingeniería, el diagnóstico, la imagenología y las terapias ganan la resolución para detectar el envejecimiento temprano y revertirlo con precisión.",

  "time.eyebrow": "El Horizonte",
  "time.h2a": "Dos años para las",
  "time.h2b": "primeras soluciones.",
  "time.m1t": "Ahora",
  "time.m1h": "Investigación a Escala Subliminal",
  "time.m1b": "Programas profundos de investigación y computación a gran escala ya están en marcha, en silencio, bajo el radar, en física, IA y biología.",
  "time.m2t": "T + 12 Meses",
  "time.m2h": "Primeras Intervenciones Candidatas",
  "time.m2b": "Los primeros resultados validados del programa pasan de la simulación a la evaluación estructurada.",
  "time.m3t": "T + 24 Meses",
  "time.m3h": "Lanzamiento de las Primeras Soluciones",
  "time.m3b": "Nuestras primeras soluciones salen al mundo. El comienzo de una cadena compuesta hacia la extensión radical de la vida.",
  "time.outro": "Mantente atento. El reloj ya está en marcha.",

  "pipe.eyebrow": "El Proceso",
  "pipe.h2a": "De la investigación fundamental a las",
  "pipe.h2b": "soluciones del mundo real.",
  "pipe.s1t": "Investigación Fundamental",
  "pipe.s1tail": "y disciplinas relacionadas.",
  "pipe.s2t": "Modelos y Descubrimiento",
  "pipe.s3t": "Tecnología",
  "pipe.s4t": "The Lifespan Labs",
  "pipe.s4d": "Un ecosistema curado de productos y servicios que apoyan una vida más saludable, más larga y mejor.",
  "pipe.s5t": "El Ecosistema de Vida Más Larga",
  "pipe.s5tail": "y soluciones orientadas a la longevidad.",

  "back.eyebrow": "El Programa",
  "back.h2a": "Primero, la",
  "back.h2b": "ecuación de la inmortalidad.",
  "back.h2c": "Después, todo lo que desbloquea.",
  "back.badge": "Prueba antes que producto",
  "back.copy": "Nuestro trabajo central es matemático: una prueba basada en la física, la ecuación de la inmortalidad, que formaliza por qué el tiempo biológico puede detenerse y revertirse. Cada solución que construimos parte de ella.",
  "back.cta1": "Suscríbete al Proyecto",
  "back.cta2": "Apóyanos",

  "sub.eyebrow": "Mantente Cerca de la Investigación",
  "sub.h2a": "Suscríbete a las novedades.",
  "sub.h2b": "Únete a la comunidad.",
  "sub.p": "Noticias de investigación, publicaciones y novedades del ecosistema, directo a tu correo. Cada nuevo suscriptor recibe una Tarjeta Digital de Membresía como Prime Member, con el primer mes gratis.",
  "sub.success.h": "Bienvenido a la comunidad.",
  "sub.success.p": "Tu Tarjeta Digital de Membresía como Prime Member está abajo, y una copia va camino a tu correo, con tu primer mes gratis.",
  "sub.download": "Descargar Tarjeta de Membresía",
  "sub.submit": "Suscríbete a las Novedades",
  "sub.sending": "Suscribiendo...",

  "form.name": "Nombre completo",
  "form.email": "Correo electrónico",
  "form.phone": "Número de contacto",
  "form.country": "País",
  "form.city": "Ciudad",
  "form.ph.name": "Tu nombre",
  "form.ph.country": "India",
  "form.ph.city": "Bombay",
  "form.error": "Algo salió mal. Inténtalo de nuevo o escribe a invest@thelifespanproject.com.",
  "form.sending": "Enviando...",

  "footer.desc": "Una iniciativa multidisciplinaria de investigación en longevidad humana, diseñando los próximos 150 años de vida humana.",
  "footer.explore": "Explorar",
  "footer.contact": "Contacto",
  "footer.legal": "Legal",
  "footer.terms": "Términos",
  "footer.privacy": "Política de Privacidad",
  "footer.refund": "Política de Reembolso",
  "footer.faq": "Preguntas Frecuentes",
  "footer.partners": "Socios Tecnológicos y Patrocinadores",
  "footer.copyright": "© 2026 The Lifespan Project. Todos los derechos reservados.",
  "footer.tagline": "La inmortalidad es teórica. 150 años es práctico.",

  "pick.title": "Elige tu vista",
  "pick.sub": "Elige un tema para comenzar. Puedes cambiarlo cuando quieras desde el encabezado.",
  "pick.dark": "Oscuro",
  "pick.dark.sub": "Cinematográfico",
  "pick.light": "Claro",
  "pick.light.sub": "Blanco degradado",

  "cookie.text": "Este sitio utiliza cookies esenciales y analítica respetuosa con la privacidad. Al continuar, aceptas nuestra",
  "cookie.accept": "Entendido",

  "inv.badge": "Relaciones con Inversores",
  "inv.h1a": "Invierte en los",
  "inv.h1b": "próximos 150 años.",
  "inv.sub": "The Lifespan Project es una iniciativa multidisciplinaria de investigación en longevidad humana. Cuéntanos quién eres y nuestro equipo te contactará con el dossier completo para inversores.",
  "inv.perks.h": "Lo que reciben los inversores",
  "inv.perk1": "Dossier completo para inversores y hoja de ruta de investigación",
  "inv.perk2": "Línea directa con el equipo fundador",
  "inv.perk3": "Data room y documentación técnica bajo petición",
  "inv.perk4": "Visibilidad anticipada del pipeline de soluciones",
  "inv.next.h": "Qué ocurre después",
  "inv.next.p": "Recibes al instante una confirmación con la marca y una copia de tu consulta. Después, nuestro equipo te contacta personalmente con el dossier para inversores. ¿Prefieres correo? Escribe a",
  "inv.org": "Organización",
  "inv.ph.org": "Fondo, institución o empresa",
  "inv.interest": "Tu interés",
  "inv.ph.interest": "Tamaño de ticket, mandato, plazos...",
  "inv.submit": "Solicitar el Dossier para Inversores",
  "inv.success.h": "Gracias, solicitud recibida.",
  "inv.success.p": "Una confirmación con la marca y una copia de tu consulta van camino a tu correo. Nuestro equipo te contactará en breve.",

  "join.badge": "Colabora con Nosotros",
  "join.h1a": "Únete al laboratorio como",
  "join.h1b": "colaborador.",
  "join.sub": "Trabajamos con investigadores, clínicos y profesionales excepcionales como becarios y colaboradores, en la ecuación de la inmortalidad y todo lo que desbloquea.",
  "join.elig.h": "Requisitos mínimos",
  "join.elig1": "Doctorado, PhD, MBBS o MD",
  "join.elig2": "O doble especialización de posgrado en cualquier área",
  "join.elig3": "Trabajando actualmente como profesional, en cualquier lugar",
  "join.elig4": "Al menos 5 años de experiencia, en India o en el extranjero",
  "join.next.h": "Qué ocurre después",
  "join.next.p": "Cada solicitud es revisada personalmente por nuestro equipo de investigación. Recibes al instante una copia por correo de tu envío, y te contactamos si hay afinidad.",
  "join.qual": "Titulación más alta",
  "join.qual.select": "Selecciona titulación",
  "join.disc": "¿Qué disciplina encaja mejor contigo?",
  "join.disc.select": "Selecciona una disciplina",
  "join.disc.unsure": "Aún no lo sé",
  "join.spec": "Especialización / área",
  "join.ph.spec": "p. ej. Biología cuántica, neurología",
  "join.exp": "Años de experiencia",
  "join.ph.exp": "Mín. 5",
  "join.role": "Rol actual y organización",
  "join.ph.role": "p. ej. Investigador científico, CSIR",
  "join.why": "¿Por qué quieres colaborar?",
  "join.ph.why": "Tus intereses de investigación, publicaciones, en qué trabajarías...",
  "join.ph.country": "India / extranjero",
  "join.submit": "Aplicar como Colaborador",
  "join.submitting": "Enviando...",
  "join.success.h": "Solicitud recibida.",
  "join.success.p": "Una copia de tu envío va camino a tu correo. Nuestro equipo de investigación revisa personalmente cada solicitud.",

  "bu.badge": "Avanzando la ciencia de la longevidad humana",
  "bu.h1a": "Conviértete en",
  "bu.h1b": "Miembro Fundador",
  "bu.h1c": "de The Lifespan Project.",
  "bu.sub": "El futuro de la longevidad humana no lo construirá una sola disciplina, un solo laboratorio o una sola tecnología. Se construirá mediante investigación, experimentación, colaboración y la traducción del conocimiento científico en soluciones tangibles. Tu membresía ayuda a impulsar ese camino.",
  "bu.projline": ": investigando la ciencia.",
  "bu.labsline": ": dando vida a las soluciones de longevidad.",

  "arch.eyebrow": "La Estructura",
  "arch.h2a": "Una misión.",
  "arch.h2b": "Dos motores.",
  "arch.proj.h": "I+D Científica",
  "arch.labs.h": "Marketplace de Longevidad",

  "flow.1": "Investigación",
  "flow.2": "Validación",
  "flow.3": "Tecnología",
  "flow.4": "Productos y Servicios",
  "flow.5": "Vida Más Larga y Saludable",

  "pos.eyebrow": "Qué Significa Ser Miembro",
  "pos.h2": "No te estás simplemente suscribiendo a contenido.",
  "pos.p": "Te estás convirtiendo en parte de la comunidad fundadora detrás de la investigación. La membresía apoya el desarrollo continuo de la investigación, el trabajo científico, el conocimiento, la experimentación y el futuro pipeline de soluciones de The Lifespan Project. A cambio, los Miembros Fundadores reciben una Membresía Digital de Fundador que los conecta con el creciente ecosistema Lifespan.",
  "pos.note": "La membresía no garantiza ningún resultado científico, resultado de salud ni aumento de la esperanza de vida.",

  "eco.eyebrow": "Membresía Digital de Fundador",
  "eco.h2a": "Tu membresía se extiende",
  "eco.h2b": "más allá de la investigación.",
  "eco.sub": "Cada Miembro Fundador recibe una Membresía Digital al creciente ecosistema Lifespan, incluido el acceso al próximo marketplace The Lifespan Labs.",
  "eco.c1n": "Salud",
  "eco.c2n": "Alimentación y Nutrición",
  "eco.c3n": "Biomarcadores y Laboratorios",
  "eco.c4n": "Médicos y Servicios de Salud",
  "eco.c5n": "Dispositivos y Máquinas",
  "eco.c6n": "Deporte y Cuerpo",
  "eco.c7n": "Sanación y Fisioterapia",
  "eco.c8n": "Mente y Psicología",
  "eco.c9n": "Mente · Cuerpo · Alma",

  "ben.eyebrow": "Beneficios del Miembro Fundador",
  "ben.h": "Lo que reciben los Miembros Fundadores",

  "mode.free": "Gratis",
  "mode.monthly": "Mensual",
  "mode.life": "De por vida",
  "cad.month": "al mes",
  "cad.life": "de por vida",
  "cad.free": "para siempre",
  "cad.month.short": "mes",
  "reg.intl": "Fuera de India",
  "reg.in": "India",

  "plan.prime.tag": "La puerta de entrada al ecosistema Lifespan.",
  "plan.prime.f1": "Tarjeta Digital de Membresía de Fundador con código escaneable",
  "plan.prime.f2": "Toda la investigación, contenido y vídeos publicados",
  "plan.prime.f3": "Acceso a The Lifespan Labs cuando se lance",
  "plan.prime.f4": "Ofertas de miembro y precios preferentes",
  "plan.prime.f5": "Envía investigación para consideración de revisión por pares",
  "plan.pro.tag": "Todo lo de Prime, de por vida. Además, el círculo interno.",
  "plan.pro.f1": "Membresía de por vida, sin renovaciones",
  "plan.pro.f2": "Lanzamientos de investigación y exclusivas solo Pro",
  "plan.pro.f3": "Invitaciones a reuniones y eventos de investigación en todo el mundo",
  "plan.pro.f4": "Descuentos mejorados en The Lifespan Labs",
  "plan.pro.f5": "Acceso prioritario a nuevos productos y servicios",
  "plan.well.tag": "Mantente cerca de la ciencia, sin coste.",
  "plan.well.f1": "Tarjeta Digital de Membresía Wellwisher con código",
  "plan.well.f2": "Noticias y novedades de la investigación",
  "plan.well.f3": "Primero en saber cuándo se lanza The Lifespan Labs",

  "cta.subscribe": "Suscríbete Aquí",
  "cta.free": "Suscríbete Gratis",
  "cta.welllink": "Suscríbete Gratis como Wellwisher",

  "why.eyebrow": "El Motivo",
  "why.h": "¿Por qué ser Miembro Fundador?",
  "why.1t": "Apoya la Investigación",
  "why.2t": "Accede al Ecosistema",
  "why.3t": "Descubre lo que Viene",
  "why.4t": "Ayuda a Moldear el Futuro",

  "flowS.eyebrow": "Cómo se Conecta",
  "flowS.h": "De la investigación a la comunidad",
  "flowS.n1t": "I+D · Ciencia · Investigación · Tecnología",
  "flowS.n2t": "Productos · Servicios · Marketplace · Acceso",
  "flowS.n3t": "Comunidad · Acceso · Participación",
  "flowS.proline": "Los Miembros Fundadores Pro pueden recibir invitaciones a reuniones de investigación, conferencias y eventos del ecosistema Lifespan Project en todo el mundo.",
  "net.caption": "Red global de investigación",

  "ck.eyebrow": "Conviértete en Miembro Fundador",
  "ck.h": "Activa tu membresía",
  "ck.submit": "Continuar al Pago Seguro",
  "ck.sending": "Abriendo el pago seguro...",
  "ck.per.month": " / mes",
  "ck.per.life": " de por vida",
  "ck.note1": "Registrado como suscripción",
  "ck.note2": ". El recibo y la factura llegan por correo.",
  "ck.invite.toggle": "¿Tienes un código de invitación?",
  "ck.invite.code": "Código de invitación",
  "ck.invite.sending": "Aplicando tu invitación...",
  "ck.invite.submit": "Canjear membresía gratis",
  "ck.invite.note": "Una invitación válida hace que el plan seleccionado sea completamente gratis.",
  "ck.invite.ph": "Introduce tu código",
  "ck.inrnote": "Se aceptan tarjetas internacionales. Razorpay cobra en INR al precio en rupias mostrado.",
  "ck.orwell": "¿Aún no estás listo para apoyar la investigación?",

  "close.h2a": "No te limites a observar el",
  "close.h2b": "futuro de la longevidad.",
  "close.h2c": "Ayuda a construirlo.",
  "close.p": "The Lifespan Project está construyendo la investigación. The Lifespan Labs reunirá el ecosistema. Los Miembros Fundadores ayudan a hacer posible ese camino y forman parte de lo que viene.",
  "close.prime": "Hazte Miembro Prime",
  "close.pro": "Hazte Miembro Pro",
  "close.or": "o",

  "res.h2a": "¿Tienes una idea?",
  "res.h2b": "Tráela al Proyecto.",
  "res.cta": "Envía tu investigación",

  "ww.eyebrow": "Gratis para siempre",
  "ww.title": "Conviértete en Wellwisher Founding Member",
  "ww.sub": "Noticias y novedades de la investigación, y tu Tarjeta Digital de Membresía Wellwisher con código escaneable, entregada al instante.",
  "ww.success.p": "Bienvenido. Tu tarjeta está abajo, y una copia va camino a tu correo.",
  "ww.submitting": "Suscribiendo...",

  "legal.notice": "Este documento legal se ofrece en inglés para preservar su significado exacto.",

  "ui.language": "Idioma",
  "ui.theme": "Tema",
};
